import { useMemo, useCallback } from "react";

import { useProvozniInformace } from "b2b/api/hooks";
import { useRedirect } from "b2b/hooks";
import { PATHS } from "b2b/constants";
import useDelete from "b2b/components/provozni-informace-cards/hooks/useDelete";
import useSubmit from "b2b/components/provozni-informace-form/hooks/useSubmit";

import useMessages from "./i18n/useMessages";

export default function useProvozniInformaceEditaceWidget(id) {
  const redirect = useRedirect();
  const messages = useMessages();
  const informaceLoader = useProvozniInformace(id);

  const initialValues = useMemo(
    () =>
      informaceLoader.data
        ? {
            ...informaceLoader.data,
            obrazek: informaceLoader.data?.obrazek
              ? [informaceLoader.data.obrazek]
              : undefined
          }
        : undefined,
    [informaceLoader.data]
  );

  const redirectToProvozniInformace = useCallback(() => {
    redirect(PATHS.PROVOZNI_INFORMACE.LIST);
  }, [redirect]);
  const onDelete = useDelete({ id, onSuccess: redirectToProvozniInformace });

  const onSubmit = useSubmit(redirectToProvozniInformace);

  return {
    title: id ? messages.pageEdit() : messages.pageNew(),
    form: {
      moduleKey: "provozniInformaceCreate",
      initialValues,
      onSubmit,
      onDelete: id !== undefined ? onDelete : undefined,
      onCancel: redirectToProvozniInformace
    }
  };
}
